import { getData, postData, patchData, deleteData } from '../utils/api';

// Get all common products with pagination and filters. When showUnitsSold is true, each product includes unitsSold.
export const getCommonProducts = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    sortField = 'name',
    sortValue = 'ASC',
    subCategoryId = '',
    isActive = '',
    searchKey = '',
    showUnitsSold = false
  } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sortField,
    sortValue,
    ...(subCategoryId && { subCategoryId }),
    ...(isActive && { isActive }),
    ...(searchKey && { searchKey }),
    ...(showUnitsSold && { showUnitsSold: 'true' })
  });

  return getData(`/data/common-product?${queryParams.toString()}`);
};

// Get single product by ID or slug
export const getCommonProductById = async (id) => {
  return getData(`/data/common-product/${id}`);
};

// Get sales stats for a common product (sales count = order count, units sold = sum of qty)
export const getCommonProductSalesStats = async (id) => {
  const res = await getData(`/data/common-product/${id}/sales-stats`);
  return res?.data != null ? res : { data: res };
};

// Create a new product
export const createCommonProduct = async (productData) => {
  const { subCategoryId, name, description, baseSku, brand, isActive = true } = productData;
  
  const requestData = {
    subCategoryId: subCategoryId || null,
    name,
    description,
    baseSku,
    brand,
    isActive
  };
  
  return postData('/data/common-product', requestData);
};

// Update an existing product
export const updateCommonProduct = async (productData) => {
  const { productId, subCategoryId, name, description, baseSku, brand, isActive } = productData;
  
  const updateData = { productId };
  
  if (subCategoryId !== undefined) updateData.subCategoryId = subCategoryId;
  if (name !== undefined) updateData.name = name;
  if (description !== undefined) updateData.description = description;
  if (baseSku !== undefined) updateData.baseSku = baseSku;
  if (brand !== undefined) updateData.brand = brand;
  if (isActive !== undefined) updateData.isActive = isActive;

  return patchData('/data/common-product', updateData);
};

// Delete a product
export const deleteCommonProduct = async (productId) => {
  return deleteData('/data/common-product', {
    data: { productId }
  });
};

export default {
  getCommonProducts,
  getCommonProductById,
  createCommonProduct,
  updateCommonProduct,
  deleteCommonProduct
};

